'use client';

import { Text } from '@savvy-kit/foundations/text';

import { SortableRowList } from './sortable-row-list';

export type TabsDraft = {
  readonly order: readonly string[];
};

type TabsPaneProps = {
  readonly draft: TabsDraft;
  readonly onChange: (next: TabsDraft) => void;
};

/** Reorder-only — no hide affordance, matching the household nav (every tab there is always shown). */
export function TabsPane({ draft, onChange }: TabsPaneProps) {
  return (
    <div className="pt-1">
      <Text variant="caption" className="mb-1 px-0.5" render={<p />}>
        Drag to reorder the tabs across the top of every household.
      </Text>
      <div className="max-h-[280px] overflow-y-auto">
        <SortableRowList
          order={draft.order}
          onReorder={(next) => onChange({ order: next })}
          labelFor={(id) => id}
          rowClassName="py-2.5"
        />
      </div>
    </div>
  );
}
